/**
 * On every successful add-to-cart (POST to /cart/add), submits the product
 * title, first-page URL (read from localStorage; written by an inline script
 * in theme.liquid <head>), current timestamp, and the source of the add
 * (e.g. product page vs. cart upsell suggestion) to a Google Form.
 */
(function () {
  'use strict';

  var GOOGLE_FORM_URL =
    'https://docs.google.com/forms/d/e/1FAIpQLScgY9ezE3H4oxNz3PcXXZPgKis4Z8jV_oWkrRHeGbu_z4EdHw/formResponse';
  var ENTRY_PRODUCT = 'entry.2005413795';
  var ENTRY_FIRSTPAGE = 'entry.1042931478';
  var ENTRY_DATETIME = 'entry.1022487512';
  var ENTRY_SOURCE = 'entry.881944668';

  // Holds the source detected from the most recent cart-add form submit
  // (capture-phase listener fires before product-form.js's submit handler
  // that actually issues the fetch, so this value is read at fetch time).
  var pendingSource = '';

  function safeGetFirstPage() {
    try {
      return localStorage.getItem('firstpage') || '';
    } catch (e) {
      return '';
    }
  }

  function sendToGoogleForm(productLabel, source) {
    var formData = new FormData();
    formData.append(ENTRY_PRODUCT, productLabel || '');
    formData.append(ENTRY_FIRSTPAGE, safeGetFirstPage());
    formData.append(ENTRY_DATETIME, new Date().toISOString());
    if (ENTRY_SOURCE) {
      formData.append(ENTRY_SOURCE, source || '');
    }

    fetch(GOOGLE_FORM_URL, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    }).catch(function (err) {
      console.error('Error logging cart-add to Google Form', err);
    });
  }

  function extractProductLabel(data) {
    if (!data || typeof data !== 'object') return '';

    // Multi-item add (when sections are requested) returns { items: [...] }.
    if (Array.isArray(data.items) && data.items.length) {
      return data.items
        .map(function (it) {
          var title = it.product_title || it.title || '';
          if (it.variant_title && it.variant_title !== 'Default Title') {
            title += ' (' + it.variant_title + ')';
          }
          return title;
        })
        .join(', ');
    }

    // Single-item add returns the line item directly.
    var title = data.product_title || data.title || '';
    if (data.variant_title && data.variant_title !== 'Default Title') {
      title += ' (' + data.variant_title + ')';
    }
    return title;
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    // Match /cart/add and /cart/add.js, including localized prefixes (/fr/cart/add).
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function detectSource(form) {
    if (!form) return 'Inconnu';
    if (form.closest('.cart-upsell')) return 'Panier - suggestion';
    return 'Fiche produit';
  }

  // Capture-phase submit listener: runs before product-form.js's own submit
  // handler (which calls fetch), so we can record where the form lives in
  // the DOM and read it back when the cart/add fetch is intercepted below.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!isCartAddUrl(action)) return;
      pendingSource = detectSource(form);
    },
    true
  );

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;

  window.fetch = function (input, init) {
    var url = '';
    var method = (init && init.method) || '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
      if (!method) method = input.method || '';
    }

    var shouldLog = isCartAddUrl(url) && (!method || method.toUpperCase() === 'POST');
    // Snapshot the source for this specific request so a later submit
    // can't overwrite it before we read it in the response handler.
    var sourceForThisRequest = pendingSource;
    if (shouldLog) pendingSource = '';

    var fetchPromise = originalFetch.apply(this, arguments);

    if (shouldLog) {
      fetchPromise
        .then(function (response) {
          if (!response || !response.ok) return;
          var clone;
          try {
            clone = response.clone();
          } catch (e) {
            return;
          }
          clone
            .json()
            .then(function (data) {
              // Shopify returns an error payload with `status` set on failure.
              if (data && data.status && data.status >= 400) return;
              var label = extractProductLabel(data);
              if (label) sendToGoogleForm(label, sourceForThisRequest);
            })
            .catch(function () {
              /* not JSON — ignore */
            });
        })
        .catch(function () {
          /* network error — ignore */
        });
    }

    return fetchPromise;
  };
})();
